import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { HeartIcon, HomeIcon, ShieldIcon, BusIcon, BuildingIcon, MonitorIcon, BedIcon, ShowerHeadIcon, TrophyIcon, HardHatIcon, GraduationCapIcon, MicIcon, StethoscopeIcon, LampIcon, LockIcon, HandIcon, ArrowRightIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
const Support = () => {
  const priorityProjects = [{
    title: 'Perimeter Fencing',
    description: 'Erection of perimeter fencing to enhance security and define school boundaries.',
    icon: <ShieldIcon className="h-6 w-6 text-blue-700" data-id="element-7051" />,
    category: 'Security',
    progress: 25
  }, {
    title: 'Street Lighting',
    description: 'Installation of strategically positioned street lighting throughout the premises for improved security and visibility.',
    icon: <LampIcon className="h-6 w-6 text-blue-700" data-id="element-7052" />,
    category: 'Security',
    progress: 15
  }, {
    title: 'Security Personnel',
    description: 'Employment of both Day and Night Security Personnel to ensure 24/7 protection of the school premises.',
    icon: <LockIcon className="h-6 w-6 text-blue-700" data-id="element-7053" />,
    category: 'Security',
    progress: 10
  }, {
    title: 'School Bus',
    description: 'Provision of a School Bus to facilitate transportation for students and staff for educational trips and events.',
    icon: <BusIcon className="h-6 w-6 text-blue-700" data-id="element-7054" />,
    category: 'Transportation',
    progress: 30
  }, {
    title: 'Administrative Block',
    description: 'Reinforcement and refurbishment of the Administrative Block to create a more functional and professional environment.',
    icon: <BuildingIcon className="h-6 w-6 text-blue-700" data-id="element-7055" />,
    category: 'Infrastructure',
    progress: 40
  }, {
    title: 'ICT Laboratory',
    description: 'Renovation of a section of the Dining Hall to function as the new ICT Laboratory with modern computing facilities.',
    icon: <MonitorIcon className="h-6 w-6 text-blue-700" data-id="element-7056" />,
    category: 'Academic Facilities',
    progress: 20
  }, {
    title: 'School Hostel',
    description: 'Revitalization of the School Hostel through the refurbishment of select buildings and extensive promotional efforts.',
    icon: <BedIcon className="h-6 w-6 text-blue-700" data-id="element-7057" />,
    category: 'Student Accommodation',
    progress: 35
  }, {
    title: 'Toilet Facilities',
    description: 'Expansion of toilet facilities for both staff and students to improve sanitation and comfort.',
    icon: <ShowerHeadIcon className="h-6 w-6 text-blue-700" data-id="element-7058" />,
    category: 'Infrastructure',
    progress: 15
  }, {
    title: 'Athletic Facilities',
    description: "Enhancement of the school's athletic facilities to promote physical education and sports excellence.",
    icon: <TrophyIcon className="h-6 w-6 text-blue-700" data-id="element-7059" />,
    category: 'Sports',
    progress: 25
  }, {
    title: 'Roof and Ceiling Repairs',
    description: 'Repair of select roofs and ceilings to ensure safe and comfortable learning environments.',
    icon: <HardHatIcon className="h-6 w-6 text-blue-700" data-id="element-7060" />,
    category: 'Infrastructure',
    progress: 45
  }, {
    title: 'Scholarship Programs',
    description: 'Introduction of additional scholarship programs for deserving students to ensure access to quality education.',
    icon: <GraduationCapIcon className="h-6 w-6 text-blue-700" data-id="element-7061" />,
    category: 'Academic Support',
    progress: 30
  }, {
    title: 'School Hall',
    description: 'Modernization of the School Hall to better accommodate assemblies, events, and performances.',
    icon: <MicIcon className="h-6 w-6 text-blue-700" data-id="element-7062" />,
    category: 'Infrastructure',
    progress: 20
  }, {
    title: 'School Clinic',
    description: 'Recruitment of healthcare professionals for the School Clinic to ensure proper medical care for students and staff.',
    icon: <StethoscopeIcon className="h-6 w-6 text-blue-700" data-id="element-7063" />,
    category: 'Health Services',
    progress: 15
  }];
  const supportCategories = [{
    title: 'Financial Donations',
    description: "Make a direct financial contribution to support our school's development projects and programs.",
    icon: <HandIcon className="h-10 w-10 text-white" data-id="element-7064" />,
    color: 'bg-blue-700',
    link: '/support/donate'
  }, {
    title: 'Material Donations',
    description: 'Donate books, computers, laboratory equipment, sports gear, and other educational materials.',
    icon: <HomeIcon className="h-10 w-10 text-white" data-id="element-7065" />,
    color: 'bg-yellow-500',
    link: '/support/material-donations'
  }, {
    title: 'Volunteer',
    description: 'Share your expertise, time, and skills to support our educational programs and extracurricular activities.',
    icon: <HeartIcon className="h-10 w-10 text-white" data-id="element-7066" />,
    color: 'bg-green-600',
    link: '/support/volunteer'
  }, {
    title: 'Corporate Partnerships',
    description: 'Explore partnership opportunities for corporate social responsibility initiatives and sponsorships.',
    icon: <BuildingIcon className="h-10 w-10 text-white" data-id="element-7067" />,
    color: 'bg-purple-600',
    link: '/support/corporate-partnerships'
  }];
  return <div className="min-h-screen bg-white" data-id="element-7068">
      <PageHeader title="Support Isonyin Grammar School" description="Join our community of supporters and help shape the future of education at Isonyin Grammar School." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Support',
      path: '/support'
    }]} data-id="element-7069" />
      <div className="container mx-auto px-4 py-12" data-id="element-7070">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-7071">
          <div className="text-center mb-10" data-id="element-7072">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7073">
              Supporting Excellence in Education
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7074"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7075">
              Your support helps us maintain our tradition of excellence and
              expand opportunities for our students.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-7076">
            <div data-id="element-7077">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-7078">
                For over five decades, Isonyin Grammar School has been committed
                to providing quality education that prepares students for future
                success. This commitment requires resources, dedication, and the
                support of our community.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-7079">
                There are many ways you can contribute to the growth and
                development of our school. Whether through financial donations,
                volunteering your time and expertise, or participating in our
                fundraising initiatives, your support makes a significant
                difference in the lives of our students.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-7080">
                By supporting Isonyin Grammar School, you are investing in the
                future of our students and our community. Join us in our mission
                to provide an exceptional educational experience that develops
                well-rounded individuals who excel academically and contribute
                positively to society.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg border border-blue-100 shadow-md" data-id="element-7081">
              <h3 className="text-xl font-bold text-blue-900 mb-4 text-center" data-id="element-7082">
                Ways to Support
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-7083">
                {supportCategories.map((category, index) => <div key={index} className="text-center" data-id="element-7084">
                    <div className={`${category.color} p-4 rounded-full inline-flex items-center justify-center mb-3`} data-id="element-7085">
                      {category.icon}
                    </div>
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-7086">
                      {category.title}
                    </h4>
                    <p className="text-sm text-gray-700 mb-3" data-id="element-7087">
                      {category.description}
                    </p>
                    <Button href={category.link} variant="text" size="sm" className="text-blue-700" data-id="element-7088">
                      Learn More
                    </Button>
                  </div>)}
              </div>
            </div>
          </div>
        </section>
        {/* Recent Commissionings Section */}
        <section className="mb-16" data-id="element-7089">
          <div className="text-center mb-10" data-id="element-7090">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7091">
              Recent Project Commissionings
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7092"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7093">
              We're proud to showcase our recently completed and commissioned
              projects that are already making a positive impact on our
              students' educational experience.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-7094">
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-7095">
              <div className="relative h-64 overflow-hidden" data-id="element-7096">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tj13uTG1CCX8nkvziVAAab/WhatsApp_Image_2025-10-24_at_10.01.17_%281%29.jpg" alt="ICT Laboratory" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-7097" />
                <div className="absolute top-4 left-4 bg-yellow-500 text-blue-900 text-xs font-bold py-1 px-2 rounded" data-id="element-7098">
                  RECENTLY COMMISSIONED
                </div>
              </div>
              <div className="p-6" data-id="element-7099">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-7100">
                  New ICT Laboratory
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-7101">
                  Our state-of-the-art ICT Laboratory was recently commissioned,
                  featuring 25 modern computer workstations, high-speed
                  internet, and educational software to enhance digital literacy
                  among our students. Donated by Old Students Association 75/80
                  Set.
                </p>
                <div className="flex items-center justify-between" data-id="element-7102">
                  <span className="text-sm text-gray-500" data-id="element-7103">
                    Commissioned: 2024
                  </span>
                  <Button href="/project-commissioning" variant="outline" size="sm" data-id="element-7104">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-7105">
              <div className="relative h-64 overflow-hidden" data-id="element-7106">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5f2egHsPW6YcMhP4RtXv/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg" alt="Chemistry Laboratory Renovation" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-7107" />
                <div className="absolute top-4 left-4 bg-yellow-500 text-blue-900 text-xs font-bold py-1 px-2 rounded" data-id="element-7108">
                  RECENTLY COMMISSIONED
                </div>
              </div>
              <div className="p-6" data-id="element-7109">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-7110">
                  Chemistry Laboratory Renovation
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-7111">
                  Our chemistry laboratory has been completely renovated with
                  new laboratory benches, modern equipment, improved
                  ventilation, and safety features. Generously donated by Old
                  Students Association 75/80 Set.
                </p>
                <div className="flex items-center justify-between" data-id="element-7112">
                  <span className="text-sm text-gray-500" data-id="element-7113">
                    Commissioned: January 27, 2024
                  </span>
                  <Button href="/project-commissioning" variant="outline" size="sm" data-id="element-7114">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-7115">
            <Button href="/project-commissioning" variant="secondary" icon={<ArrowRightIcon data-id="element-7117" />} iconPosition="right" data-id="element-7116">
              View All Commissioned Projects
            </Button>
          </div>
        </section>
        {/* Current Needs / Priority Projects Section */}
        <section className="mb-16" id="priority-projects" data-id="element-7118">
          <div className="text-center mb-10" data-id="element-7119">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7120">
              Current Needs & Priority Projects
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7121"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7122">
              These are the specific areas where the school requires financial
              or material support to improve our facilities and enhance the
              educational experience of our students.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7123">
            {priorityProjects.map((project, index) => <Card key={index} hover className="h-full" data-id="element-7124">
                <div className="flex items-start" data-id="element-7125">
                  <div className="bg-blue-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-7126">
                    {project.icon}
                  </div>
                  <div data-id="element-7127">
                    <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mb-2" data-id="element-7128">
                      {project.category}
                    </span>
                    <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-7129">
                      {project.title}
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-7130">{project.description}</p>
                    <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-7131">
                      <div className="bg-blue-600 h-2.5 rounded-full" style={{
                    width: `${project.progress}%`
                  }} data-id="element-7132"></div>
                    </div>
                    <div className="flex justify-between mt-2 text-sm" data-id="element-7133">
                      <span className="text-gray-600" data-id="element-7134">Progress</span>
                      <span className="text-blue-700 font-medium" data-id="element-7135">
                        {project.progress}%
                      </span>
                    </div>
                  </div>
                </div>
              </Card>)}
          </div>
        </section>
        {/* Donation Process Section */}
        <section className="mb-16" data-id="element-7136">
          <div className="text-center mb-10" data-id="element-7137">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7138">
              How to Donate
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7139"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7140">
              Making a donation to Isonyin Grammar School is simple and secure.
              Follow these steps to contribute to our development projects.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7141">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-7142">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7143">
                <span className="text-blue-700 font-bold text-xl" data-id="element-7144">1</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-7145">
                Choose a Project
              </h3>
              <p className="text-gray-700" data-id="element-7146">
                Select a specific project you'd like to support or make a
                general donation to the school.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-7147">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7148">
                <span className="text-blue-700 font-bold text-xl" data-id="element-7149">2</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-7150">
                Contact Us
              </h3>
              <p className="text-gray-700" data-id="element-7151">
                Reach out to our development office to discuss your donation and
                receive transfer details.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-7152">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7153">
                <span className="text-blue-700 font-bold text-xl" data-id="element-7154">3</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-7155">
                Make Your Donation
              </h3>
              <p className="text-gray-700" data-id="element-7156">
                Complete your donation via bank transfer, check, or in-person at
                our administrative office.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-7157">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7158">
                <span className="text-blue-700 font-bold text-xl" data-id="element-7159">4</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-7160">
                Receive Acknowledgment
              </h3>
              <p className="text-gray-700" data-id="element-7161">
                Get an official receipt and acknowledgment of your generous
                contribution to our school.
              </p>
            </div>
          </div>
          <div className="mt-10 text-center" data-id="element-7162">
            <Button href="/contact" variant="primary" size="lg" icon={<ArrowRightIcon data-id="element-7164" />} iconPosition="right" data-id="element-7163">
              Contact Our Development Office
            </Button>
          </div>
        </section>
        {/* Recognition Section */}
        <section className="mb-16 bg-blue-50 p-8 rounded-lg" data-id="element-7165">
          <div className="text-center mb-10" data-id="element-7166">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7167">
              Donor Recognition
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7168"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7169">
              We appreciate and recognize the generosity of our donors who
              contribute to the development of Isonyin Grammar School.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-7170">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-7171">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-7172">
                Donor Wall
              </h3>
              <p className="text-gray-700 text-center" data-id="element-7173">
                Major donors are recognized on our Donor Wall located in the
                school's main administration building, showcasing their
                significant contributions to our development.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-7174">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-7175">
                Annual Report
              </h3>
              <p className="text-gray-700 text-center" data-id="element-7176">
                All donors are acknowledged in our Annual Report, which
                highlights the school's achievements and the impact of donations
                on our programs and facilities.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-7177">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-7178">
                Naming Opportunities
              </h3>
              <p className="text-gray-700 text-center" data-id="element-7179">
                Significant donations may qualify for naming opportunities,
                allowing donors to name a facility, scholarship, or program in
                honor of themselves or a loved one.
              </p>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden" data-id="element-7180">
          <div className="container mx-auto px-4 py-12" data-id="element-7181">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-7182">
              <div data-id="element-7183">
                <h2 className="text-3xl font-bold mb-4" data-id="element-7184">
                  Make a Difference Today
                </h2>
                <p className="mb-6 leading-relaxed" data-id="element-7185">
                  Your support, regardless of size, can make a significant
                  impact on the lives of our students and the future of Isonyin
                  Grammar School. Join us in our mission to provide quality
                  education and develop future leaders.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-7186">
                  <Button href="/contact" variant="primary" size="lg" data-id="element-7187">
                    Contact Us
                  </Button>
                  <Button href="/support/donate" variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-7188">
                    Donate Now
                  </Button>
                </div>
              </div>
              <div className="relative" data-id="element-7189">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Students at Isonyin Grammar School" className="rounded-lg shadow-lg" data-id="element-7190" />
                <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-blue-900 font-bold py-2 px-4 rounded-lg transform rotate-3 shadow-lg" data-id="element-7191">
                  Thank You for Your Support!
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default Support;